// @ts-nocheck
// FX state belongs to the parent checkout. These fields are assertions only;
// the backend verifies them against the confirmed, account-scoped Stripe intent.
const normalizeCurrency = (currency) =>
  typeof currency === 'string' ? currency.toUpperCase() : undefined;

const getMinorUnits = (amount) => {
  const scaled = amount * 100;
  const minorUnits = Math.round(scaled);
  if (
    !Number.isFinite(amount) ||
    amount <= 0 ||
    !Number.isSafeInteger(minorUnits) ||
    Math.abs(scaled - minorUnits) >
      Number.EPSILON * Math.max(1, Math.abs(scaled)) * 4
  ) {
    return null;
  }
  return minorUnits;
};

export const hasFxPaymentSelection = (selection, operatorCurrency) =>
  Boolean(
    selection &&
    (selection.fxQuoteId ||
      (selection.currency &&
        normalizeCurrency(selection.currency) !==
          normalizeCurrency(operatorCurrency)))
  );

export const buildFxTransactionFields = (
  selection,
  operatorCurrency,
  operatorAmount
) => {
  if (!hasFxPaymentSelection(selection, operatorCurrency)) return {};

  const currency = normalizeCurrency(selection.currency);
  const operatorCode = normalizeCurrency(operatorCurrency);
  const chargeAmount = Number(selection.chargeAmount);
  const lockedRate = Number(selection.lockedRate);
  const operatorCredit = Number(selection.operatorBookingCredit);
  const chargeMinorUnits = getMinorUnits(chargeAmount);
  const creditMinorUnits = getMinorUnits(operatorCredit);
  const selectedMinorUnits = getMinorUnits(Number(operatorAmount));

  if (
    !/^[A-Z]{3}$/.test(currency || '') ||
    !/^[A-Z]{3}$/.test(operatorCode || '') ||
    currency === operatorCode ||
    typeof selection.fxQuoteId !== 'string' ||
    !selection.fxQuoteId?.startsWith('fxq_') ||
    chargeMinorUnits === null ||
    !Number.isFinite(lockedRate) ||
    lockedRate <= 0 ||
    selection.operatorBookingCredit == null ||
    creditMinorUnits === null ||
    selectedMinorUnits === null ||
    creditMinorUnits !== selectedMinorUnits
  ) {
    throw new Error('FX payment selection requires a matching server quote');
  }

  return {
    chargecurrency: currency,
    chargeamount: chargeMinorUnits / 100,
    fxquoteid: selection.fxQuoteId,
    lockedrate: lockedRate,
    amountappliedtobalance: creditMinorUnits / 100
  };
};
